// PostgreSQL usa 55P03 quando un guard NOWAIT rifiuta una scrittura che
// arriverebbe con ordine di lock inverso rispetto a StockCommand. È una
// contesa transitoria, non un errore di dominio: eliminare l'operazione dopo il
// vecchio limite di cinque tentativi perderebbe silenziosamente una modifica
// offline valida.
const RETRYABLE_POSTGRES_CODES = new Set([
  '40P01', // deadlock_detected (compatibilità con writer precedenti)
  '40001', // serialization_failure
  '55P03', // lock_not_available / NOWAIT
]);

const RETRYABLE_SYNC_REASONS = new Set([
  'account_context_unavailable',
  'cleaning_product_reference_unavailable',
  'dedup_check_failed',
  // Compatibilità con Edge precedenti che non includevano lo SQLSTATE.
  'insert_failed',
]);

export function isRetryableSyncRejection(reason: string): boolean {
  if (RETRYABLE_SYNC_REASONS.has(reason.trim().toLowerCase())) return true;
  const normalized = reason.trim().toUpperCase();
  for (const code of RETRYABLE_POSTGRES_CODES) {
    if (
      normalized === code
      || normalized.endsWith(`:${code}`)
    ) {
      return true;
    }
  }
  return false;
}

// Nome mantenuto per i caller/test storici; eventi e master condividono gli
// stessi SQLSTATE transitori e devono avere la stessa politica di retry.
export const isRetryableMasterRejection = isRetryableSyncRejection;

export function shouldQuarantineRejectedSyncOp(reason: string): boolean {
  return !isRetryableSyncRejection(reason);
}
